/** FilterChip — chip toggle reusável para filtros mobile */

interface FilterChipProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * Chip selecionável para grupos de filtro.
 * Ativo: fundo mint, borda transparente.
 * Inativo: fundo card-soft, borda card-stroke.
 * Touch target ≥ 44px de altura garantido pelo padding vertical.
 */
export function FilterChip({ active, onClick, children }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      aria-pressed={active}
      style={{
        padding: '9px 13px',
        borderRadius: 'var(--r-pill)',
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        background: active ? 'var(--mint)' : 'var(--card-soft)',
        color: active ? 'var(--on-mint, #1F3A2E)' : 'var(--fg-muted)',
        border: active ? '1px solid transparent' : '1px solid var(--card-stroke)',
        cursor: 'pointer',
        minHeight: 38,
        lineHeight: 1,
      }}
    >
      {children}
    </button>
  );
}
